<template>
  
<div class="container">
      <h3 class="heading">المحاضر</h3>

      <form @submit.prevent="postinfo">
  
     

  <div class="mb-3 input-in-con  ">
           <div v-if="err">
  <div v-if="err.inquisitor"  class="alert alert-danger" role="alert"> {{ err.inquisitor[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">المحقق</label>
 <select class="form-select " aria-label="Default select example" v-model="formdata.inquisitor" >
  <option disabled selected>اختر المحقق</option>
  <option  v-for="key in formdata2" :value="key.id">{{key.name}}</option>
</select>
</div>

  <div class="mb-3 input-in-con  ">
           <div v-if="err">
  <div v-if="err.accused_and_victim"  class="alert alert-danger" role="alert"> {{ err.accused_and_victim[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">الجاني او المتهم</label>
 <select class="form-select " aria-label="Default select example" v-model="formdata.accused_and_victim" >
  <option disabled selected>اختر الجاني او المتهم</option>
  <option  v-for="key in formdata3" :value="key.id">{{key.name}}</option>
</select>
</div>

<div class="flex last">
  <button  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>


</template>

<script setup>
import { ref,onMounted, render } from 'vue'
import { useRouter } from 'vue-router'
import  geturl  from "@/comp/geturl";


const formdata = ref({
    inquisitor:null,
    accused_and_victim:null
})
const formdata2 = ref(null)
const formdata3 = ref(null)
const err = ref(null)
const router = useRouter()


onMounted(()=>{

    fetch(geturl()+"records/inquisitor/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata2.value = data
        })

    fetch(geturl()+"complaints/accused_and_victim/", {
        
        headers: {"Content-Type": "application/json"},
        })
        .then(res => res.json())
        .then(data => {formdata3.value = data
        })

})

const postinfo = () => {

fetch(geturl()+"records/record/", {
         method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(formdata.value)
      })
      .then(res => res.json())
      .then(data => { 
        if(data.error){
          err.value = data.error.details
                  }
      else{
        router.push({name:'RecordView' })
      }
      })

}
</script>

<style>

</style>